import React from 'react';
import { Badge as CBadge, BadgeProps as CBadgeProps } from '@chakra-ui/react';
import classNames from 'classnames';
import { useTranslations } from '@/core/translations';
import styles from './Badge.module.scss';

interface BadgeProps extends Omit<CBadgeProps, 'children'> {
  label: 'beta' | 'trial';
}

export const Badge: React.FC<BadgeProps> = ({ className, label, ...props }) => {
  const t = useTranslations('badge');
  return (
    <CBadge
      className={classNames(styles.root, className, {
        [styles.isBeta]: label === 'beta',
      })}
      variant="solid"
      borderRadius="var(--borderRadius)"
      fontSize="12px"
      fontWeight={500}
      textTransform="none"
      {...props}
    >
      {t(label)}
    </CBadge>
  );
};
